var _path, _rect, _circle, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatePickingUpOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6133 15.6279C13.6133 13.4188 15.4041 11.6279 17.6133 11.6279H48.0678C50.2769 11.6279 52.0678 13.4188 52.0678 15.6279V26.6082C50.4536 26.9435 48.9397 27.5524 47.5766 28.3841V21.5938C47.5766 21.0415 47.1289 20.5938 46.5766 20.5938H19.6655C19.1132 20.5938 18.6655 21.0415 18.6655 21.5938V59.5605C18.6655 60.1128 19.1132 60.5605 19.6655 60.5605H46.5766C47.1289 60.5605 47.5766 60.1128 47.5766 59.5605V52.6912C48.9397 53.5229 50.4536 54.1318 52.0678 54.4671V62.8105C52.0678 65.0197 50.2769 66.8105 48.0678 66.8105H17.6133C15.4041 66.8105 13.6133 65.0197 13.6133 62.8105V15.6279Z",
    fill: "url(#paint0_linear_667_9229)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.9287,
    y: 14.9619,
    width: 11.0439,
    height: 2.24552,
    rx: 1.12276,
    fill: "url(#paint1_linear_667_9229)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.9766,
    cy: 40.5372,
    r: 11.9972,
    fill: "url(#paint2_linear_667_9229)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.437 35.5732L53.9867 43.6002L50.4121 40.0256",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_667_9229",
    x1: 32.8405,
    y1: 11.6279,
    x2: 32.8405,
    y2: 66.8105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589396,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960459,
    stopColor: "#EEF3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_667_9229",
    x1: 28.6645,
    y1: 17.2074,
    x2: 38.9725,
    y2: 17.2074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98DCB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_667_9229",
    x1: 42.9795,
    y1: 44.2999,
    x2: 71.2202,
    y2: 44.2999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90CDAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0EEC1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatePickingUpOn);
export default __webpack_public_path__ + "static/media/state_picking_up_on.423f966cb7f685a56bc17628b7045394.svg";
export { ForwardRef as ReactComponent };